import templateUrl from './reference-maps-switch-tab.html';

export const referenceMapsSwitchTabComponent = {
	templateUrl,

	bindings: {
		data: '<'
	},

	controller: class ReferenceMapsSwitchTabComponent {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/reference-maps-switch-tab/reference-maps-switch-tab.component.js